import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { dispatch } from '../../redux/store';
import DesktopLandingPage from './DesktopLandingPage';

const ScreenSizeCheck = ({ children }) => {
    const [width, setWidth] = useState(window.innerWidth);
    const [currentPathname, setCurrentPath] = useState('');

    const urlSearchParams = new URLSearchParams(window.location.search);
    const allowedPaths = [
        '/profile',
        '/settings',
        '/settings/security',
        '/edit-profile',
        '/profile/physical',
        '/user/comment'
    ];

    const handleWindowSizeChange = () => {
        setWidth(window.innerWidth);
    };

    const { userInfo } = useSelector(state => state.auth.authUser);
    const { loggedInUser } = useSelector(({ user }) => ({
        loggedInUser: user.data
    }));

    const getProfile = async userId => {
        if (userId) {
            await dispatch.user.getUserProfileForGuest({ id: userId });
            return;
        }

        if (!userId && !loggedInUser && userInfo.id) {
            await dispatch.user.getUserProfile({ id: userInfo?.id });
        }
    };

    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);

        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        };
    }, []);

    useEffect(() => {
        const path = window.location.pathname;
        setCurrentPath(path);

        if (path === '/profile') {
            getProfile(urlSearchParams.get('id'));
        }
    }, [window.location.pathname, urlSearchParams.get('id')]);

    const isAllowedToView =
        width <= 768 || allowedPaths.includes(currentPathname);

    return isAllowedToView ? <>{children}</> : <DesktopLandingPage />;
};

export default ScreenSizeCheck;
